/**
 * Build a create DTO for any touchpoint type
 */
export function buildTouchPointCreateDto(formData, campaignId, webId) {
    switch (formData.Type) {
        case 'Email':
            return buildEmailCreateDto(formData, campaignId, webId);
        case 'Meeting':
            return buildMeetingCreateDto(formData, campaignId, webId);
        case 'Phone':
            return buildPhoneCreateDto(formData, campaignId, webId);
        case 'Social':
            return buildSocialCreateDto(formData, campaignId, webId);
        default:
            throw new Error(`Unsupported touchpoint type: ${formData.Type}`);
    }
}
/**
 * Build an update DTO for any touchpoint type
 */
export function buildTouchPointUpdateDto(formData, existingETag) {
    switch (formData.Type) {
        case 'Email':
            return buildEmailUpdateDto(formData, existingETag);
        case 'Meeting':
            return buildMeetingUpdateDto(formData, existingETag);
        case 'Phone':
            return buildPhoneUpdateDto(formData, existingETag);
        case 'Social':
            return buildSocialUpdateDto(formData, existingETag);
        default:
            throw new Error(`Unsupported touchpoint type: ${formData.Type}`);
    }
}
/**
 * Build a create DTO for an Email touchpoint
 */
export function buildEmailCreateDto(formData, campaignId, webId) {
    // Convert date string (YYYY-MM-DD) to UTC midnight ISO string
    const scheduledDate = new Date(formData.ScheduledDate + 'T00:00:00.000Z');
    return {
        CampaignId: campaignId,
        WebId: webId,
        Name: formData.Name,
        Type: formData.Type,
        EmailProperties: formData.Type === 'Email' && formData.EmailSubject && formData.EmailBody
            ? {
                Subject: formData.EmailSubject,
                Body: formData.EmailBody,
                ScheduledDate: scheduledDate.toISOString(),
            }
            : undefined,
    };
}
/**
 * Build an update DTO for an Email touchpoint
 */
export function buildEmailUpdateDto(formData, existingETag) {
    // Convert date string (YYYY-MM-DD) to UTC midnight ISO string
    const scheduledDate = new Date(formData.ScheduledDate + 'T00:00:00.000Z');
    return {
        Name: formData.Name,
        ETag: formData.ETag || existingETag,
        EmailProperties: formData.Type === 'Email' && formData.EmailSubject && formData.EmailBody
            ? {
                Subject: formData.EmailSubject,
                Body: formData.EmailBody,
                ScheduledDate: scheduledDate.toISOString(),
            }
            : undefined,
    };
}
/**
 * Build a create DTO for a Meeting touchpoint
 */
export function buildMeetingCreateDto(formData, campaignId, webId) {
    return {
        CampaignId: campaignId,
        WebId: webId,
        Name: formData.Name,
        Type: formData.Type,
        MeetingProperties: formData.Type === 'Meeting' && formData.MeetingType && formData.TimeZone && formData.StartTime && formData.EndTime
            ? {
                Type: formData.MeetingType,
                TimeZone: formData.TimeZone,
                StartTime: formData.StartTime,
                EndTime: formData.EndTime,
                MeetingUrlLink: formData.MeetingUrlLink,
            }
            : undefined,
    };
}
/**
 * Build an update DTO for a Meeting touchpoint
 */
export function buildMeetingUpdateDto(formData, existingETag) {
    return {
        Name: formData.Name,
        ETag: formData.ETag || existingETag,
        MeetingProperties: formData.Type === 'Meeting' && formData.MeetingType && formData.TimeZone && formData.StartTime && formData.EndTime
            ? {
                Type: formData.MeetingType,
                TimeZone: formData.TimeZone,
                StartTime: formData.StartTime,
                EndTime: formData.EndTime,
                MeetingUrlLink: formData.MeetingUrlLink,
            }
            : undefined,
    };
}
/**
 * Build a create DTO for a Phone touchpoint
 */
export function buildPhoneCreateDto(formData, campaignId, webId) {
    // Convert date string (YYYY-MM-DD) to UTC midnight ISO string
    const scheduledDate = new Date(formData.ScheduledDate + 'T00:00:00.000Z');
    return {
        CampaignId: campaignId,
        WebId: webId,
        Name: formData.Name,
        Type: formData.Type,
        PhoneProperties: formData.Type === 'Phone' && formData.NumberOfDials !== undefined
            ? {
                ScheduledDate: scheduledDate.toISOString(),
                NumberOfDials: formData.NumberOfDials,
            }
            : undefined,
    };
}
/**
 * Build an update DTO for a Phone touchpoint
 */
export function buildPhoneUpdateDto(formData, existingETag) {
    // Convert date string (YYYY-MM-DD) to UTC midnight ISO string
    const scheduledDate = new Date(formData.ScheduledDate + 'T00:00:00.000Z');
    return {
        Name: formData.Name,
        ETag: formData.ETag || existingETag,
        PhoneProperties: formData.Type === 'Phone' && formData.NumberOfDials !== undefined
            ? {
                ScheduledDate: scheduledDate.toISOString(),
                NumberOfDials: formData.NumberOfDials,
            }
            : undefined,
    };
}
/**
 * Build a create DTO for a Social touchpoint
 */
export function buildSocialCreateDto(formData, campaignId, webId) {
    // Convert date string (YYYY-MM-DD) to UTC midnight ISO string
    const scheduledDate = new Date(formData.ScheduledDate + 'T00:00:00.000Z');
    return {
        CampaignId: campaignId,
        WebId: webId,
        Name: formData.Name,
        Type: formData.Type,
        SocialProperties: formData.Type === 'Social' && formData.PostCopy && formData.Platform
            ? {
                ScheduledDate: scheduledDate.toISOString(),
                PostCopy: formData.PostCopy,
                Platform: formData.Platform,
            }
            : undefined,
    };
}
/**
 * Build an update DTO for a Social touchpoint
 */
export function buildSocialUpdateDto(formData, existingETag) {
    // Convert date string (YYYY-MM-DD) to UTC midnight ISO string
    const scheduledDate = new Date(formData.ScheduledDate + 'T00:00:00.000Z');
    return {
        Name: formData.Name,
        ETag: formData.ETag || existingETag,
        SocialProperties: formData.Type === 'Social' && formData.PostCopy && formData.Platform
            ? {
                ScheduledDate: scheduledDate.toISOString(),
                PostCopy: formData.PostCopy,
                Platform: formData.Platform,
            }
            : undefined,
    };
}
